module.exports = __webpack_public_path__ + "img/Unidad17-6.3afed057.png";